import { render, staticRenderFns } from "./SelfAwarenessPage.vue?vue&type=template&id=eb41b676&"
import script from "./SelfAwarenessPage.vue?vue&type=script&lang=js&"
export * from "./SelfAwarenessPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports